import type { MediaTranscript } from "@circle-react/types/MediaTranscript";
import { Form } from "@circle-react-uikit/Form";
import { TranscriptFormBody } from "./TranscriptFormBody";

interface ManageTranscriptMenuProps {
  isUpdating?: boolean;
  mediaTranscript: MediaTranscript;
  updateAsync?: (values: any) => void;
}

const getDefaultValues = (mediaTranscript: MediaTranscript) => ({
  enabled: !!mediaTranscript?.enabled,
  selected_file: mediaTranscript?.selected_file,
});

export const ManageTranscriptMenu = ({
  mediaTranscript,
  updateAsync,
  isUpdating,
}: ManageTranscriptMenuProps) => {
  if (!mediaTranscript) {
    return null;
  }
  const defaultValues = getDefaultValues(mediaTranscript);

  const onSubmit = (values: any) => {
    updateAsync?.(values);
  };

  return (
    <Form
      id="media-transcript"
      onSubmit={onSubmit}
      defaultValues={defaultValues}
    >
      <TranscriptFormBody
        isUpdating={!!isUpdating}
        supportsAi={!!mediaTranscript?.supports_ai}
        aiFileDownloadUrl={
          (mediaTranscript?.is_ai_ready && mediaTranscript?.webvtt_file_url) ||
          ""
        }
      />
    </Form>
  );
};
